import React, { useEffect, useRef, useState } from "react";

const CustomCursor = () => {
  const cursorRef = useRef(null);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const moveCursor = (e) => {
      if (cursorRef.current) {
        cursorRef.current.style.left = e.clientX + "px";
        cursorRef.current.style.top = e.clientY + "px";
      }
    };

    const hoverEnter = () => setHover(true);
    const hoverLeave = () => setHover(false);

    document.addEventListener("mousemove", moveCursor);
    document.querySelectorAll("button, a, .cursor-hover").forEach((el) => {
      el.addEventListener("mouseenter", hoverEnter);
      el.addEventListener("mouseleave", hoverLeave);
    });

    return () => {
      document.removeEventListener("mousemove", moveCursor);
      document.querySelectorAll("button, a, .cursor-hover").forEach((el) => {
        el.removeEventListener("mouseenter", hoverEnter);
        el.removeEventListener("mouseleave", hoverLeave);
      });
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: hover ? "28px" : "16px",
        height: hover ? "28px" : "16px",
        backgroundColor: hover ? "#6366F1" : "#f87171",
        borderRadius: "50%",
        pointerEvents: "none",
        transform: "translate(-50%, -50%)",
        transition: "all 0.15s ease-out",
        zIndex: 9999,
        mixBlendMode: "difference",
        boxShadow: "0 0 12px rgba(255,255,255,0.6), 0 0 24px rgba(99,102,241,0.5)"
      }}
    />
  );
};

export default CustomCursor;